import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { Addendum, UUID } from "@/core/types";

import { addendumKeys } from "../keyFactory";
import { getNoteAddendums } from "../queryFunctions/getNoteAddendums";

type UseNoteAddendumsProps<TData = Addendum[]> = {
  noteId: UUID;
  patientId: UUID;
  select?: (data: Addendum[]) => TData;
};

type NoteAddendumsQueryOptions = UseQueryOptions<
  Addendum[],
  unknown,
  Addendum[],
  ReturnType<typeof addendumKeys.byNote>
>;

export function useNoteAddendums<TData = Addendum[]>({
  noteId,
  patientId,
  select,
}: UseNoteAddendumsProps<TData>) {
  return useQuery({ ...optionFactory(patientId, noteId), select });
}

function optionFactory(patientId: UUID, noteId: UUID) {
  return {
    queryFn: () => getNoteAddendums(patientId, noteId),
    queryKey: addendumKeys.byNote(noteId),
    refetchOnWindowFocus: "always",
    staleTime: 0,
  } satisfies NoteAddendumsQueryOptions;
}
